module.exports = __webpack_public_path__ + "static/media/issue_update_icon1.8fcf21f2.svg";